import {Component} from '@angular/core';



export class  BaseEntryForm<T>{

}